module.exports = __webpack_public_path__ + "static/media/loginProfile.b8569056.svg";